import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/tabar/Home.vue'

Vue.use(VueRouter)
//获取原型对象上的push函数
const originalPush = VueRouter.prototype.push
//修改原型对象中的push方法
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: { title: '首页', navShow: true }
  },
  {
    path: '/login',
    name: 'Login',
    meta: { title: '登入' },
    component: () => import(/* webpackChunkName: "about" */ '../views/login/login.vue')
  },
  {
    path: '/package',
    name: 'Package',
    meta: { title: '包裹', navShow: true },
    component: () => import(/* webpackChunkName: "about" */ '../views/tabar/Package.vue')
  },
  {
    path: '/order',
    name: 'Order',
    meta: { title: '訂單', navShow: true },
    component: () => import(/* webpackChunkName: "about" */ '../views/tabar/Order.vue')
  },
  {
    path: '/my',
    name: 'My',
    meta: { title: '我的', navShow: true },
    component: () => import(/* webpackChunkName: "about" */ '../views/tabar/My.vue')
  },
  {
    path: '/feadback',
    name: 'Feadback',
    meta: { title: '用户反馈' },
    component: () => import(/* webpackChunkName: "about" */ '../views/tabar/feadback.vue')
  },
  {
    path: '/fankuilist',
    name: 'Fankuilist',
    meta: { title: '反馈记录' },
    component: () => import(/* webpackChunkName: "about" */ '../views/tabar/fankuilist.vue')
  },
  {
    path: '/parse',
    name: 'Parse',
    component: () => import(/* webpackChunkName: "about" */ '../views/view/parse.vue')
  },
  {
    path: '/payPage',
    name: 'PayPage',
    component: () => import(/* webpackChunkName: "about" */ '../views/view/payPage.vue')
  },
  {
    path: '/problem',
    name: 'Problem',
    meta: { title: '常見問題' },
    component: () => import(/* webpackChunkName: "about" */ '../views/view/problem.vue')
  },
  {
    path: '/try',
    name: 'Try',
    meta: { title: '運費試算' },
    component: () => import(/* webpackChunkName: "about" */ '../views/view/try.vue')
  }, {
    path: '/server',
    name: 'Server',
    meta: { title: '服務價格' },
    component: () => import(/* webpackChunkName: "about" */ '../views/view/server.vue')
  }, {
    path: '/server',
    name: 'Server',
    meta: { title: '服務價格' },
    component: () => import(/* webpackChunkName: "about" */ '../views/view/server.vue')
  }, {
    path: '/packLogin',
    name: 'PackLogin',
    meta: { title: '查看物流' },
    component: () => import(/* webpackChunkName: "about" */ '../views/view/packLogin.vue')
  },{
    path: '/orderLogin',
    name: 'OrderLogin',
    meta: { title: '查看物流' },
    component: () => import(/* webpackChunkName: "about" */ '../views/view/orderLogin.vue')
  }, {
    path: '/ordgetinfo',
    name: 'Ordgetinfo',
    meta: { title: '查看物流' },
    component: () => import(/* webpackChunkName: "about" */ '../views/view/ordgetinfo.vue')
  }, {
    path: '/predition',
    name: 'Predition',
    meta: { title: '包裹預報' },
    component: () => import(/* webpackChunkName: "about" */ '../views/package/predition.vue')
  }, {
    path: '/returnAddress',
    name: 'ReturnAddress',
    meta: { title: '退貨地址' },
    component: () => import(/* webpackChunkName: "about" */ '../views/package/return/address.vue')
  }, {
    path: '/returnOrder',
    name: 'ReturnOrder',
    meta: { title: '退貨訂單' },
    component: () => import(/* webpackChunkName: "about" */ '../views/package/return/return.vue')
  }, {
    path: '/goodname',
    name: 'Goodname',
    meta: { title: '物品名稱' },
    component: () => import(/* webpackChunkName: "about" */ '../views/package/goodname.vue')
  },{
    path: '/goodUrl',
    name: 'GoodUrl',
    meta: { title: '商品鏈接' },
    component: () => import(/* webpackChunkName: "about" */ '../views/package/goodUrl.vue')
  }, {
    path: '/packdetail',
    name: 'Packdetail',
    meta: { title: '包裹詳情' },
    component: () => import(/* webpackChunkName: "about" */ '../views/package/packdetail.vue')
  }, {
    path: '/packSearch',
    name: 'PackSearch',
    meta: { title: '包裹' },
    component: () => import(/* webpackChunkName: "about" */ '../views/package/packSearch.vue')
  }, {
    path: '/orderpack',
    name: 'Orderpack',
    meta: { title: '創建訂單' },
    component: () => import(/* webpackChunkName: "about" */ '../views/opeartion/orderpack.vue')
  }, {
    path: '/orderDetail',
    name: 'OrderDetail',
    meta: { title: '訂單詳情' },
    component: () => import(/* webpackChunkName: "about" */ '../views/opeartion/orderDetail.vue')
  }, {
    path: '/orderSearch',
    name: 'OrderSearch',
    meta: { title: '訂單' },
    component: () => import(/* webpackChunkName: "about" */ '../views/opeartion/orderSearch.vue')
  }, {
    path: '/pay',
    name: 'Pay',
    meta: { title: '收銀臺' },
    component: () => import(/* webpackChunkName: "about" */ '../views/opeartion/pay.vue')
  }, {
    path: '/coup',
    name: 'Coup',
    meta: { title: '優惠券' },
    component: () => import(/* webpackChunkName: "about" */ '../views/coup/coup.vue')
  }, {
    path: '/message',
    name: 'Message',
    meta: { title: '最新消息' },
    component: () => import(/* webpackChunkName: "about" */ '../views/coup/message.vue')
  }, {
    path: '/useRepert',
    name: 'UseRepert',
    meta: { title: '帳號資訊' },
    component: () => import(/* webpackChunkName: "about" */ '../views/userOperation/useRepert.vue')
  }, {
    path: '/repertPassward',
    name: 'RepertPassward',
    meta: { title: '修改密碼' },
    component: () => import(/* webpackChunkName: "about" */ '../views/userOperation/repertPassward.vue')
  }, {
    path: '/addAddres',
    name: 'AddAddres',
    meta: { title: '新增海外地址' },
    component: () => import(/* webpackChunkName: "about" */ '../views/userOperation/addAddres.vue')
  }, {
    path: '/addressUser',
    name: 'AddressUser',
    meta: { title: '海外地址管理' },
    component: () => import(/* webpackChunkName: "about" */ '../views/userOperation/address.vue')
  }, {
    path: '/transaction',
    name: 'Transaction',
    meta: { title: '交易記錄' },
    component: () => import(/* webpackChunkName: "about" */ '../views/view/transaction.vue')
  }, {
    path: '/address',
    name: 'Address',
    meta: { title: '交易記錄' },
    component: () => import(/* webpackChunkName: "about" */ '../views/view/address.vue')
  }, {
    path: '/checkadres',
    name: 'Checkadres',
    meta: { title: '選擇自提點' },
    component: () => import(/* webpackChunkName: "about" */ '../views/opeartion/checkadres.vue')
  },
  {
    path: '/ifram',
    name: 'Ifram',
    meta: { title: '選擇自提點' },
    component: () => import(/* webpackChunkName: "about" */ '../views/opeartion/ifram.vue')
  },{
    path: '/userjifen',
    name: 'Userjifen',
    meta: { title: '任務中心' },
    component: () => import(/* webpackChunkName: "about" */ '../views/jifen/uisejifen.vue')
  },{
    path: '/jinfedetaile',
    name: 'Jinfedetaile',
    meta: { title: '積分明細' },
    component: () => import(/* webpackChunkName: "about" */ '../views/jifen/jinfedetaile.vue')
  },
  // {
  //   path: '/jinfeduihuan',
  //   name: 'Jinfeduihuan',
  //   meta: { title: '積分兌換' },
  //   component: () => import(/* webpackChunkName: "about" */ '../views/jifen/jinfeduihuan.vue')
  // },
  {
    path: '/duihuanlist',
    name: 'Duihuanlist',
    meta: { title: '兌換記錄' },
    component: () => import(/* webpackChunkName: "about" */ '../views/jifen/duihuanlist.vue')
  },{
    path: '/goodeDetaile',
    name: 'GoodeDetaile',
    meta: { title: '商品詳情' },
    component: () => import(/* webpackChunkName: "about" */ '../views/jifen/goodeDetaile.vue')
  },{
    path: '/chongzhi',
    name: 'Chongzhi',
    meta: { title: '我的錢包' },
    component: () => import(/* webpackChunkName: "about" */ '../views/chongzhi/chongzhi.vue')
  },{
    path: '/chongzhiList',
    name: 'ChongzhiList',
    meta: { title: '賬戶充值' },
    component: () => import(/* webpackChunkName: "about" */ '../views/chongzhi/list.vue')
  },{
    path: '/listDetail',
    name: 'ListDetail',
    meta: { title: '余額明細' },
    component: () => import(/* webpackChunkName: "about" */ '../views/chongzhi/listDetail.vue')
  }, {
    path: '/declarant',
    name: 'Declarant',
    meta: { title: '增加申報人' },
    component: () => import(/* webpackChunkName: "about" */ '../views/opeartion/declarant.vue')
  }, {
    path: '/enterpriseModal',
    name: 'EnterpriseModal',
    meta: { title: '增加企业信息' },
    component: () => import(/* webpackChunkName: "about" */ '../views/package/enterpriseModal.vue')
  }, {
    path: '/bindTaoBaoShop',
    name: 'BindTaoBaoShop',
    meta: { title: '綁定淘寶' },
    component: () => import(/* webpackChunkName: "about" */ '../views/opeartion/bindTaoBaoShop.vue')
  }, {
    path: '/clear',
    name: 'Clear',
    meta: { title: '清理缓存' },
    component: () => import(/* webpackChunkName: "about" */ '../views/cllear/index.vue')
  },{
    path: '/custor',
    name: 'Custor',
    meta: { title: '新增海外地址' },
    component: () => import(/* webpackChunkName: "about" */ '../views/userOperation/index.vue')
  },
  {
    path: '/grandlisy',
    name: 'Grandlisy',
    meta: { title: '用户等级' },
    component: () => import(/* webpackChunkName: "about" */ '../views/tabar/grandlisy.vue')
  },
  {
    path: '/upDataImg',
    name: 'UpDataImg',
    meta: { title: '补全包裹' },
    component: () => import(/* webpackChunkName: "about" */ '../views/opeartion/upDataImg.vue')
  },

  {
    path: '/404',
    name: 'notFound',
    meta: { title: '错误页' },
    component: () => import(/* webpackChunkName: "about" */ '../views/view/404.vue')
  }, {
    path: "*",
    redirect: "/404"
  }
]

const router = new VueRouter({
  // mode: 'history',
  base: process.env.BASE_URL,
  routes
})
router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  next()
})
export default router
